/**********************************************************************
 *
 * Copyright (C) 2022 Almendo Technologies GmbH
 * Copyright (C) 2022 Marcus Harringer
 *
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of
 * Marcus Harringer. The intellectual and technical concepts contained
 * herein are proprietary to Marcus Harringer and may be covered
 * copyright law. Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written permission
 * is obtained from Marcus Harringer.
 *
 ***********************************************************************/


import client from './BluSensorGraphqlClient';

import {
  getUser,
  getUserPublic
} from '../../graphql/queries'



import { logError } from '../log/Logger';
import { updateUser } from '../../graphql/mutations';


/***************************************************************************
 * API: USER
 ***************************************************************************/
//also see AmplifyContext.js

async function apiGetUser(user_id) {

  try {

    let apiResult = await client.graphql({ query: getUser, variables: { user_id: user_id } });

    return apiResult.data.getUser;

  } catch (err) {
    logError("getUser", err);
    return null;
  }
}


async function apiGetUserPublic(user_id) {

  try {

    let apiResult = await client.graphql({ query: getUserPublic, variables: { user_id: user_id } });
    return apiResult.data.getUserPublic;

  } catch (err) {
    logError("apiGetUserPublic", err);
    return null;
  }


}
async function apiUpdateUser(update) {



  try {
    await client.graphql({ query: updateUser, variables: { input: update } });
  } catch (err) {
    logError("apiUpdateUser", err);

  }

}

/***************************************************************************
 * MODULE EXPORTES
 ***************************************************************************/
export {
  apiGetUser,
  apiGetUserPublic,
  apiUpdateUser
}